module.exports = __webpack_public_path__ + "static/media/Pic-0069.ea53c124.jpg";